import React, { useState } from 'react';
import { auth } from '../firebase';
import { GoogleAuthProvider, OAuthProvider, signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, fetchSignInMethodsForEmail, signInWithCredential } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { logError } from '../utils/errorLogger';
import { Alert, Collapse } from '@mui/material';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow:wght@300;400;600&display=swap');
  .tbv-login-page { all: initial; }
  .tbv-login-page *, .tbv-login-page *::before, .tbv-login-page *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .tbv-login-page {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    min-height: 100vh; background: #0D1E35; font-family: 'Barlow', sans-serif;
    padding: 36px 16px; overflow-x: hidden;
  }
  .tbv-login-header { display: flex; flex-direction: column; align-items: center; margin-bottom: 32px; animation: tbv-fadeDown 0.7s ease both; }
  .tbv-login-card {
    background: rgba(255,255,255,0.06); border: 1px solid rgba(201,168,76,0.2);
    border-radius: 16px; padding: 36px 32px; width: 100%; max-width: 400px;
    animation: tbv-fadeUp 0.6s 0.15s ease both; opacity: 0; animation-fill-mode: forwards;
  }
  .tbv-login-title {
    font-family: 'Bebas Neue', sans-serif; font-size: 1.8rem; letter-spacing: 3px;
    color: white; text-align: center; margin-bottom: 4px;
  }
  .tbv-login-sub {
    font-size: 0.78rem; font-weight: 300; color: rgba(255,255,255,0.35);
    text-align: center; letter-spacing: 1px; margin-bottom: 28px;
  }
  .tbv-divider {
    width: 40px; height: 1px; background: linear-gradient(90deg, transparent, #C9A84C, transparent);
    margin: 0 auto 28px;
  }
  .tbv-btn {
    width: 100%; display: flex; align-items: center; justify-content: center; gap: 10px;
    padding: 13px 20px; border-radius: 8px; border: none; cursor: pointer;
    font-family: 'Barlow', sans-serif; font-size: 0.9rem; font-weight: 600;
    letter-spacing: 0.5px; transition: all 0.2s ease; margin-bottom: 12px;
  }
  .tbv-btn-google {
    background: rgba(255,255,255,0.08); color: white;
    border: 1px solid rgba(255,255,255,0.15);
  }
  .tbv-btn-google:hover { background: rgba(255,255,255,0.14); border-color: rgba(255,255,255,0.3); }
  .tbv-btn-apple { background: white; color: #000; }
  .tbv-btn-apple:hover { background: #e8e8e8; }
  .tbv-admin-toggle {
    background: none; border: none; cursor: pointer; font-family: 'Barlow', sans-serif;
    font-size: 0.7rem; color: rgba(255,255,255,0.2); letter-spacing: 1px;
    display: block; margin: 16px auto 0; transition: color 0.2s;
  }
  .tbv-admin-toggle:hover { color: rgba(201,168,76,0.5); }
  .tbv-email-link {
    background: none; border: none; cursor: pointer; font-family: 'Barlow', sans-serif;
    font-size: 0.72rem; color: rgba(201,168,76,0.6); letter-spacing: 0.5px;
    display: block; margin: 2px auto 0; transition: color 0.2s; padding: 4px;
  }
  .tbv-email-link:hover { color: #C9A84C; }
  .tbv-admin-section { margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 20px; }
  .tbv-admin-label {
    font-size: 0.65rem; font-weight: 600; letter-spacing: 2px; text-transform: uppercase;
    color: rgba(201,168,76,0.5); text-align: center; margin-bottom: 16px;
  }
  .tbv-input {
    width: 100%; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12);
    border-radius: 6px; padding: 10px 14px; color: white; font-family: 'Barlow', sans-serif;
    font-size: 0.88rem; margin-bottom: 10px; outline: none; transition: border-color 0.2s;
  }
  .tbv-input::placeholder { color: rgba(255,255,255,0.3); }
  .tbv-input:focus { border-color: rgba(201,168,76,0.5); }
  .tbv-btn-signin {
    background: linear-gradient(135deg, #C9A84C, #e0be6a); color: #0D1E35;
    font-weight: 700; letter-spacing: 1px;
  }
  .tbv-btn-signin:hover { background: linear-gradient(135deg, #e0be6a, #C9A84C); }
  .tbv-btn-signin:disabled { opacity: 0.5; cursor: not-allowed; }
  .tbv-value {
    background: rgba(201,168,76,0.06); border: 1px solid rgba(201,168,76,0.18);
    border-radius: 10px; padding: 14px 16px 12px; margin: -8px 0 22px;
  }
  .tbv-value-title {
    font-size: 0.78rem; font-weight: 600; color: #C9A84C; letter-spacing: 0.5px; margin-bottom: 8px;
  }
  .tbv-value ul { margin: 0; padding: 0; list-style: none; }
  .tbv-value li {
    font-size: 0.78rem; font-weight: 300; color: rgba(255,255,255,0.7); line-height: 1.45;
    padding-left: 18px; position: relative; margin-bottom: 5px;
  }
  .tbv-value li::before { content: '✓'; position: absolute; left: 0; color: #C9A84C; font-weight: 600; }
  .tbv-legal {
    font-size: 0.65rem; color: rgba(255,255,255,0.2); text-align: center;
    margin-top: 20px; line-height: 1.6;
  }
  .tbv-legal a { color: rgba(201,168,76,0.5); text-decoration: none; }
  .tbv-legal a:hover { color: #C9A84C; }
  .tbv-footer { margin-top: 28px; font-size: 0.65rem; color: rgba(255,255,255,0.15); letter-spacing: 2px; text-transform: uppercase; }
  @keyframes tbv-fadeDown { from { opacity: 0; transform: translateY(-16px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes tbv-fadeUp { from { opacity: 0; transform: translateY(22px); } to { opacity: 1; transform: translateY(0); } }
`;

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
const appleProvider = new OAuthProvider('apple.com');

function Login() {
  const [error, setError] = useState('');
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [signingIn, setSigningIn] = useState(false);
  const [emailMode, setEmailMode] = useState('signin'); // 'signin' | 'create'
  const [info, setInfo] = useState('');
  const navigate = useNavigate();

  const handleAccountLink = async (err, pendingCredential) => {
    if (err.code !== 'auth/account-exists-with-different-credential') throw err;
    // Find which provider the email is registered with
    const email = err.customData?.email;
    if (!email) throw err;
    const methods = await fetchSignInMethodsForEmail(auth, email);
    // Sign in with the existing provider, then link the new credential
    let existingProvider;
    if (methods.includes('google.com')) existingProvider = googleProvider;
    else if (methods.includes('apple.com')) existingProvider = appleProvider;
    else throw err;
    const result = await signInWithPopup(auth, existingProvider);
    await result.user.linkWithCredential(pendingCredential);
  };

  const handleGoogleLogin = async () => {
    try {
      setError('');
      const token = new URLSearchParams(window.location.search).get('token');
      if (token) sessionStorage.setItem('inviteToken', token);
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      try {
        const pendingCredential = GoogleAuthProvider.credentialFromError(err);
        if (pendingCredential) { await handleAccountLink(err, pendingCredential); return; }
      } catch (linkErr) {
        logError('Login', 'Account link failed: ' + linkErr.code, linkErr.message);
        setError('Could not link accounts. Please try again.');
        return;
      }
      logError('Login', 'Google sign-in failed: ' + err.code, err.message);
      setError('Google sign-in failed. Please try again.');
    }
  };

  const handleAppleLogin = async () => {
    try {
      setError('');
      const token = new URLSearchParams(window.location.search).get('token');
      if (token) sessionStorage.setItem('inviteToken', token);
      await signInWithPopup(auth, appleProvider);
    } catch (err) {
      try {
        const pendingCredential = OAuthProvider.credentialFromError(err);
        if (pendingCredential) { await handleAccountLink(err, pendingCredential); return; }
      } catch (linkErr) {
        logError('Login', 'Account link failed: ' + linkErr.code, linkErr.message);
        setError('Could not link accounts. Please try again.');
        return;
      }
      logError('Login', 'Apple sign-in failed: ' + err.code, err.message);
      setError('Apple sign-in failed. Please try again.');
    }
  };

  // If this email is already registered with Google/Apple, point the user at
  // the right button instead of a dead-end "invalid password" message. May
  // return '' when email enumeration protection hides the provider list.
  const existingOauthHint = async (em) => {
    try {
      const methods = await fetchSignInMethodsForEmail(auth, em);
      if (methods.includes('google.com')) return 'This email is linked to a Google sign-in — use the "Continue with Google" button above.';
      if (methods.includes('apple.com')) return 'This email is linked to an Apple sign-in — use the "Continue with Apple" button above.';
    } catch (e) { /* enumeration protection or offline — fall through */ }
    return '';
  };

  const stashInviteToken = () => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (token) sessionStorage.setItem('inviteToken', token);
  };

  const handleEmailLogin = async () => {
    if (!email || !password) { setError('Please enter your email and password.'); return; }
    setSigningIn(true);
    setError(''); setInfo('');
    stashInviteToken();
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
    } catch (err) {
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        logError('Login', 'Failed login attempt: ' + err.code, email);
        setError((await existingOauthHint(email.trim())) || 'Invalid email or password.');
      } else {
        logError('Login', 'Email sign-in failed: ' + err.code, err.message);
        setError('Sign-in failed. Please try again.');
      }
      setSigningIn(false);
    }
  };

  const handleEmailCreate = async () => {
    if (!email || !password) { setError('Please enter an email and choose a password.'); return; }
    setSigningIn(true);
    setError(''); setInfo('');
    stashInviteToken();
    try {
      await createUserWithEmailAndPassword(auth, email.trim(), password);
      // onAuthStateChanged in App.js takes it from here — pending-doc linking
      // and /register routing are provider-agnostic.
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') {
        setError((await existingOauthHint(email.trim())) || 'An account already exists for this email — sign in instead.');
        setEmailMode('signin');
      } else if (err.code === 'auth/weak-password') {
        setError('Password must be at least 6 characters.');
      } else if (err.code === 'auth/invalid-email') {
        setError('That email address doesn\u2019t look valid.');
      } else {
        logError('Login', 'Email account creation failed: ' + err.code, err.message);
        setError('Could not create the account. Please try again.');
      }
      setSigningIn(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) { setError('Enter your email above first, then tap "Forgot password?" again.'); return; }
    setError(''); setInfo('');
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setInfo(`Password reset email sent to ${email.trim()}. Check your inbox (and spam folder).`);
    } catch (err) {
      if (err.code === 'auth/invalid-email') setError('That email address doesn\u2019t look valid.');
      else setInfo(`If an account exists for ${email.trim()}, a reset email is on its way.`);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="tbv-login-page">
        <header className="tbv-login-header">
          <img src="/horzlogo.png" alt="Torch Beach Volleyball"
               style={{ maxWidth: 280, width: '70vw', objectFit: 'contain' }} />
        </header>

        <div className="tbv-login-card">
          <div className="tbv-login-title">Member Portal</div>
          <div className="tbv-login-sub">Sign in to manage your account</div>
          <div className="tbv-divider" />

          {/* Why sign in at all, before asking for it. Only what the app
              really shows a parent today. */}
          <div className="tbv-value">
            <div className="tbv-value-title">New here? Here’s what your account gives you</div>
            <ul>
              <li>Each athlete’s session balance, always up to date</li>
              <li>Your purchase history and receipts</li>
              <li>Reserve practices straight from the live schedule</li>
              <li>Contact details and the waiver, entered once</li>
            </ul>
          </div>

          {error && (
            <Alert severity="error" sx={{ mb: 2, fontSize: '0.82rem' }}>{error}</Alert>
          )}

          {/* Google */}
          <button className="tbv-btn tbv-btn-google" onClick={handleGoogleLogin}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style={{ width: 18, height: 18 }} aria-hidden="true">
              <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
              <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
              <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
              <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
            </svg>
            Continue with Google
          </button>

          {/* Apple */}
          <button className="tbv-btn tbv-btn-apple" onClick={handleAppleLogin}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{ width: 15, height: 15, marginTop: -2 }} fill="currentColor" aria-hidden="true">
              <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
            </svg>
            Continue with Apple
          </button>

          {/* Admin email toggle */}
          <button className="tbv-admin-toggle" onClick={() => { setShowEmail(s => !s); setError(''); setInfo(''); }}>
            {showEmail ? 'hide' : 'sign in with email'}
          </button>

          <Collapse in={showEmail}>
            <div className="tbv-admin-section">
              <div className="tbv-admin-label">{emailMode === 'create' ? 'Create Account' : 'Email Sign In'}</div>
              {info && (
                <Alert severity="success" sx={{ mb: 1.5, fontSize: '0.78rem' }}>{info}</Alert>
              )}
              <input
                className="tbv-input" type="email" placeholder="Email"
                value={email} onChange={e => setEmail(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && (emailMode === 'create' ? handleEmailCreate() : handleEmailLogin())}
              />
              <input
                className="tbv-input" type="password" placeholder={emailMode === 'create' ? 'Choose a password (6+ characters)' : 'Password'}
                value={password} onChange={e => setPassword(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && (emailMode === 'create' ? handleEmailCreate() : handleEmailLogin())}
              />
              {emailMode === 'create' ? (
                <>
                  <button className="tbv-btn tbv-btn-signin" onClick={handleEmailCreate} disabled={signingIn}>
                    {signingIn ? 'Creating account…' : 'Create Account'}
                  </button>
                  <button className="tbv-email-link" onClick={() => { setEmailMode('signin'); setError(''); setInfo(''); }}>
                    Already have an account? Sign in
                  </button>
                </>
              ) : (
                <>
                  <button className="tbv-btn tbv-btn-signin" onClick={handleEmailLogin} disabled={signingIn}>
                    {signingIn ? 'Signing in…' : 'Sign In'}
                  </button>
                  <button className="tbv-email-link" onClick={handlePasswordReset}>
                    Forgot password?
                  </button>
                  <button className="tbv-email-link" onClick={() => { setEmailMode('create'); setError(''); setInfo(''); }}>
                    New here? Create an account with email
                  </button>
                </>
              )}
            </div>
          </Collapse>

          <div className="tbv-legal">
            By signing in you agree to our{' '}
            <a href="/terms">Terms of Service</a>
            {' '}and{' '}
            <a href="/privacy">Privacy Policy</a>.
          </div>
        </div>

        <footer className="tbv-footer">
          © {new Date().getFullYear()} Torch Beach Volleyball · Geneva, FL
        </footer>
      </div>
    </>
  );
}

export default Login;
